// Branded confirmation dialog for the Fangate UI — a drop-in replacement for the
// native, unbranded `window.confirm()`. A single <FangateConfirmHost> is mounted
// once in FangateLayout; any component calls `confirm(...)` and awaits a boolean.
//
//   const { confirm } = useFangateConfirm();
//   if (!(await confirm({ title: 'Remove agent?', message: '…', danger: true }))) return;
//
import { reactive } from 'vue';

// Module-level singleton so every caller drives the same host instance.
const state = reactive({
  open: false,
  title: '',
  message: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  danger: false,
});
let resolver = null;

export function useFangateConfirm() {
  const confirm = (opts = {}) =>
    new Promise(resolve => {
      // If a dialog is somehow already open, resolve the previous one as cancel.
      if (resolver) resolver(false);
      state.title = opts.title ?? 'Are you sure?';
      state.message = opts.message ?? '';
      state.confirmLabel = opts.confirmLabel ?? 'Confirm';
      state.cancelLabel = opts.cancelLabel ?? 'Cancel';
      state.danger = opts.danger ?? false;
      state.open = true;
      resolver = resolve;
    });
  return { confirm };
}

// Used only by FangateConfirmHost to render state and settle the promise.
export function useFangateConfirmHost() {
  const settle = value => {
    state.open = false;
    const r = resolver;
    resolver = null;
    if (r) r(value);
  };
  return { state, settle };
}
